var map = {
	"./color-chart.jpg": 167265,
	"./stock_product-2-28.jpg": 984993,
	"./stock_product-2-29.jpg": 306948,
	"./stock_product-2-30.jpg": 11282,
	"./stock_product-2-31.jpg": 406044,
	"./stock_product-color-chart.jpg": 884496,
	"./stock_product-sample-pack.jpg": 32446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 707825;